import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import Usuario from "../../../../models/usuario";
import { IconX } from "@tabler/icons-react";
import TabelaArgumentos from "../../../util/tabelas/tabelaArgumentos";
import { onSnapshot, query } from "firebase/firestore";
import { map } from "lodash";
import Imposto from "../../../../models/imposto";
import ImpostoDb from "../../../../db/impostoDb";

type Props = {
  onClose: () => void;
  open: boolean;
  cliente: Usuario;
};

export default function Analisar({ onClose, open, cliente }: Props) {
  const [impostos, setImpostos] = useState<Imposto[]>();

  useEffect(() => {
    if (!!cliente) {
      return onSnapshot(
        query(
          new ImpostoDb().collection({
            usuarioId: cliente.id,
            impostoId: "",
          })
        ),
        (query) => {
          if (!query.empty) setImpostos(map(query.docs, (doc) => doc.data()));
          else setImpostos(undefined);
        }
      );
    }
  }, [cliente]);

  return (
    <>
      <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth>
        <DialogTitle sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="flex-start"
            gap={2}
          >
            <Typography variant="h3" component="span" color="text.primary">
              {`Análise dos cálculos de `}
              <Box
                component="span"
                sx={{ fontStyle: "italic", color: "accentInk" }}
              >
                {cliente.nome}
              </Box>
            </Typography>
            <IconButton aria-label="close" size="small" onClick={onClose}>
              <IconX />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ py: 4, px: 4 }}>
          <TabelaArgumentos impostos={impostos} />
        </DialogContent>
      </Dialog>
    </>
  );
}
